define('models/page',['require','models/base/model'],function(require) {
    'use strict';

    var Model = require('models/base/model');

    var Page = Model.extend({
        getHelpId: function() {
            return this.get('action').split('#')[0];
        }
    });

    return Page;
});
